import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { GetPurchaseOrders } from "api/models/request/purchase-order/purchase-order";
import { PurchaseOrderPagination } from "api/models/response/pagination";
import {
  createConditionalNaturalLanguageString,
  formatNumber,
} from "commons/ultilities";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";
import { IOrderProperties, Order } from "mobx-stores/_models/orders/order";
import { OrderItem } from "mobx-stores/_models/orders/order-item";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";
export const OrderQueryParams = types
  .model({
    poDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    deliveryDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    code: "",
    name: "",
    dealingName: "",
    pONumber: "",
    barcode: "",
    showSuccess: false,
    isExactMatch: true,
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get natureLanguageString() {
      const map = new Map<
        string,
        { label: string; value: string | number | null | undefined }
      >([
        ["dealingName", { label: "tên giao dịch", value: self.dealingName }],
        ["name", { label: "tên hàng", value: self.name }],
        ["code", { label: "mã hàng", value: self.code }],
        ["pONumber", { label: "số PO", value: self.pONumber }],
        ["barcode", { label: "mã barcode", value: self.barcode }],
      ]);

      return createConditionalNaturalLanguageString(map);
    },
  }));

export const ExcelQueryParams = types
  .model({
    poDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    showSuccess: true,
  })
  .actions(withSetPropAction);

export const OrderManagement = types
  .model({
    orders: types.optional(types.array(Order), []),
    pagination: types.optional(PaginationStore, {}),
    orderDetail: types.maybeNull(Order),
    selectedOrderItem: types.maybeNull(OrderItem),
    openNew: false,
    openEdit: false,
    openDelete: false,
    openManageStatus: false,
    openEditPrice: false,
    openExportExcel: false,
    queryParams: types.optional(OrderQueryParams, {}),
    excelParams: types.optional(ExcelQueryParams, {}),
    totalWeight: 0,
    totalProductCount: 0,
    searchConditionAsNaturalLanguage: "",
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    createSearchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.natureLanguageString;
      return `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      }Tổng số lượng: ${formatNumber(self.totalProductCount)} pcs - Tổng trọng lượng: ${formatNumber(self.totalWeight)} kg`;
    },
  }))
  .actions((self) => ({
    getOrders: flow(function* getOrders(request?: GetPurchaseOrders) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            fromPODate:
              self.queryParams.poDateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.poDateRangeFilter.from
                ? self.queryParams.poDateRangeFilter.from
                : undefined,
            toPODate:
              self.queryParams.poDateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.poDateRangeFilter.to
                ? self.queryParams.poDateRangeFilter.to
                : undefined,
            fromDeliveryDate:
              self.queryParams.deliveryDateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.deliveryDateRangeFilter.from
                ? self.queryParams.deliveryDateRangeFilter.from
                : undefined,
            toDeliveryDate:
              self.queryParams.deliveryDateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.deliveryDateRangeFilter.to
                ? self.queryParams.deliveryDateRangeFilter.to
                : undefined,
            dealingName: self.queryParams.dealingName,
            name: self.queryParams.name,
            pONumber: self.queryParams.pONumber,
            showSuccess: self.queryParams.showSuccess,
            code: self.queryParams.code,
            barcode: self.queryParams.barcode,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield orderBusiness.getLists<GetPurchaseOrders>(
          request,
        )) as PurchaseOrderPagination<IOrderProperties>;
        self.setProp(
          "orders",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          })),
        );
        self.setProp("totalWeight", res.totalWeight || 0);
        self.setProp("totalProductCount", res.totalProductCount || 0);
        self.pagination.setProp("totalItems", res.totalCount);
        self.setProp(
          "searchConditionAsNaturalLanguage",
          self.createSearchConditionAsNaturalLanguage(),
        );
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getOrderDetail: flow(function* getOrderDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield orderBusiness.getById(id)) as IOrderProperties;
        self.setProp("orderDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
